var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinOld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1059_24268)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 2,
    width: 15,
    height: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6712 0.5H1.32875C0.976344 0.5 0.638371 0.639993 0.389182 0.889182C0.139993 1.13837 0 1.47634 0 1.82875V17.1712C0 17.5237 0.139993 17.8616 0.389182 18.1108C0.638371 18.36 0.976344 18.5 1.32875 18.5H16.6712C17.0237 18.5 17.3616 18.36 17.6108 18.1108C17.86 17.8616 18 17.5237 18 17.1712V1.82875C18 1.47634 17.86 1.13837 17.6108 0.889182C17.3616 0.639993 17.0237 0.5 16.6712 0.5ZM5.365 15.8337H2.65875V7.2375H5.365V15.8337ZM4.01 6.04625C3.70302 6.04452 3.40344 5.9519 3.14905 5.78007C2.89466 5.60823 2.69688 5.3649 2.58066 5.08077C2.46444 4.79664 2.43499 4.48444 2.49602 4.18359C2.55706 3.88274 2.70585 3.60671 2.92362 3.39034C3.14138 3.17396 3.41836 3.02695 3.7196 2.96785C4.02084 2.90874 4.33283 2.9402 4.61621 3.05824C4.89959 3.17628 5.14165 3.37563 5.31185 3.63111C5.48204 3.88659 5.57274 4.18677 5.5725 4.49375C5.5754 4.69928 5.53688 4.90328 5.45926 5.0936C5.38163 5.28393 5.26649 5.45668 5.12068 5.60155C4.97487 5.74643 4.80139 5.86046 4.61057 5.93686C4.41975 6.01326 4.2155 6.05047 4.01 6.04625ZM15.34 15.8412H12.635V11.145C12.635 9.76 12.0463 9.3325 11.2863 9.3325C10.4838 9.3325 9.69625 9.9375 9.69625 11.18V15.8412H6.99V7.24375H9.5925V8.435H9.6275C9.88875 7.90625 10.8038 7.0025 12.2 7.0025C13.71 7.0025 15.3412 7.89875 15.3412 10.5238L15.34 15.8412Z",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1059_24268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinOld);
export default __webpack_public_path__ + "static/media/linkedin-old.418bcfaa84438283923f0407f3ffd570.svg";
export { ForwardRef as ReactComponent };